export const scroll = function (el) {
    console.log("SCroll Lisnteres");
    if (document.body.classList.contains("body--light")) {
        window.addEventListener("scroll", function () {
            const topbar = document
                .querySelector(".topbar .container")
                .getBoundingClientRect();
            const max = window.innerHeight - (topbar.top + topbar.height / 2);
            if (
                document.documentElement.scrollTop > max &&
                document.body.classList.contains("body--light")
            ) {
                document.body.classList.remove("body--light");
            } else if (
                document.documentElement.scrollTop <= max &&
                !document.body.classList.contains("body--light")
            ) {
                document.body.classList.add("body--light");
            }
        });
    }
};
